import { useState } from 'react';

import { usePreAuthFinePrint } from 'reservations/account/providers/ConfigProvider';
import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { IconTypographyContainer } from 'reservations/base/components/IconTypography';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { useBookingGuests } from 'reservations/booking/providers/BookingProvider';
import {
  EvenSplitIconTypography,
  GuestsEnrolledIconTypography,
  PrivatePaymentIconTypography
} from 'reservations/checklessPayments/components/SplitBillIconTypography';
import { CHECKLESS_BILL_SPLITTING_SUBHEADER } from 'reservations/checklessPayments/constants';
import { PaymentForm } from 'reservations/payments/components/PaymentForm';

export const AddCardToSplitGuestModal = () => {
  const [handleSaveCard, setHandleSaveCard] = useState<() => void>(() => {});
  const [addingCard, setAddingCard] = useState(false);
  const guests = useBookingGuests();
  const { open } = useModal();

  const numberOfEnrolledGuests = guests?.filter(
    guest => guest.opt_in_checkless
  ).length;

  const handleAddCardClick = () => {
    setAddingCard(true);
  };

  const handleNextClick = async () => {
    await handleSaveCard?.();
    open(ModalType.SelectGratuity);
  };

  return (
    <BaseDrawer
      header="Add your card to split the bill"
      subheader={CHECKLESS_BILL_SPLITTING_SUBHEADER}
      primaryButton={{
        label: addingCard ? 'NEXT' : 'ADD CARD',
        onClick: addingCard ? handleNextClick : handleAddCardClick
      }}
      secondaryButton={{ label: 'MAYBE LATER' }}
      footer={usePreAuthFinePrint()}
      requireAuth={addingCard}
    >
      <IconTypographyContainer>
        <EvenSplitIconTypography />
        <GuestsEnrolledIconTypography
          numberOfEnrolledGuests={numberOfEnrolledGuests}
        />
        <PrivatePaymentIconTypography />
      </IconTypographyContainer>
      {addingCard && <PaymentForm setHandleSaveCard={setHandleSaveCard} />}
    </BaseDrawer>
  );
};
